import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorError(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="#DC3232"
      />
      <path d="M12 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z" fill="#fff" />
      <circle cx="12" cy="17" r="1" fill="#fff" />
    </BaseIcon>
  );
}
